import { LoadOptions } from 'devextreme/data/load_options';
import FileSystemItem from 'devextreme/file_management/file_system_item';
import AppValues from 'src/app/common/app.values';
import { DataItem, FileDataItem } from 'src/app/interfaces';
import { RequestDataActivityLog } from 'src/app/interfaces/activity.interface';

import { FilePermissions, FoldersResponseInner, SecurityDescriptor } from 'src/app/swagger-api';
import { SortCategories } from 'src/app/views/sort-elements/sort-drop-down/sort-drop-down.helpers';

export enum HistoryChangesTypes {
  uploaded = 'uploaded',
  viewed = 'viewed',
  downloaded = 'downloaded',
  changed = 'changed',
  shared = 'shared',
  unshared = 'unshared',
}

export function dxFileToFoldersResponseInnerAdapter(items: FileSystemItem[]): FoldersResponseInner[] {
  return items.map((item: FileSystemItem) => (item.dataItem as FileDataItem).dataItem.item) as FoldersResponseInner[];
}

export const loadOptionsToParams: (loadOptions: LoadOptions) => RequestDataActivityLog = (loadOptions: LoadOptions) => {
  type SortDescriptor = Array<{ selector: string; desc: boolean }>;

  const ordering: SortDescriptor = (loadOptions.sort as SortDescriptor) || [{ desc: false, selector: '' }];

  return {
    offset: loadOptions.skip || AppValues.ACTIVITIES_PAGE_OFFSET,
    limit: loadOptions.take || AppValues.PAGE_LIMIT,
    sorting: ordering[0].desc ? SortCategories.DATE_DESC : SortCategories.DATE_ASC,
  };
};

export const allowedManage: (userId: string, dataItem: DataItem) => boolean = (userId: string, dataItem: DataItem) => {
  const security: SecurityDescriptor | undefined = dataItem?.item.security.find(
    (descriptor: SecurityDescriptor) => descriptor.user_id === userId,
  );

  return security?.permission === FilePermissions.Owner && !dataItem.item.entity.is_public;
};
